import { Component, Input } from '@angular/core';
import { AccommodationService } from '../../accommodation.service';

@Component({
	selector: 'app-accommodation-list-availabilities',
	templateUrl: './accommodation-list-availabilities.component.html',
	styleUrls: ['./accommodation-list-availabilities.component.css'],
})
export class AccommodationListAvailabilitiesComponent {
	@Input() show;
	@Input() availabilities: Array<any> = [];

	constructor(public service: AccommodationService) {}
}
